// import GeetestSy from 'geetest-sy'
import SyCaptcha from 'sy-captcha'
import Vue from 'vue'
import toast from '@/components/common/toast/index.js'
import loading from '@/components/common/loading/index.js'

import { mutations } from '@/observable/store'
import { CacheModule } from '@/utils/commonUtils'
import { passport, loginMobile } from '@/model/api/loginService.js'



Vue.use(toast)
Vue.use(loading)

// 验证弹框
const geet = () => {
  Vue.$loading.show()

  return new Promise((resolve, reject) => {
    // var senseOptions = {
    //   initType: 'sense', // 是否使用深知模式,不使用就不写
    //   initGt: {
    //     senseID: '39972a813f8696146efb3f2261cedfa1', // 深知ID，如果使用深知模式必传，ID请找server确认，不同端不同页面都有可能不一致
    //     handler: function (sense) {
    //       Vue.$loading.hide()

    //       sense.sense()
    //       sense.setInfos(function () {
    //         return {
    //           interactive: 1
    //         }
    //       }).onSuccess(function (data) {
    //         resolve(data)
    //       }).onClose(err => { //当用户关闭弹出来的验证时，会触发该回调。
    //       }).onError(function (err) {
    //         reject(err)
    //       })
    //     }
    //   }
    // }
    // new GeetestSy(senseOptions)

    const initConfig = {
      mode: 'select',
      product: 'popup',
      width: '80%',
      smCaptchaCallback: (SMCaptcha) => {
        SMCaptcha.onClose(() => {
          Vue.$loading.hide()
          console.log('popup 时关闭回调');
          reject('验证码弹窗关闭！');
        }).onSuccess((data) => {
          Vue.$loading.hide()
          if (data.pass) {
            console.log('onSuccess', data)
            resolve(data);
          }
        }).onReady((dom, params) => {
          // console.log(`验证码 onReady ${params.type}`)
          SMCaptcha.verify();
        })
      }
    }
    new SyCaptcha(initConfig);
  })

}

// 发送验证码
const loginGetCode = (data = { phone: '', challenge: '' }) => {
  Vue.$loading.show()

  let parme = {
    country_code: "86",
    // sense_id: "39972a813f8696146efb3f2261cedfa1",
    ...data
  }
  return new Promise((resolve, reject) => {
    passport(parme).then(data => {
      Vue.$loading.hide()

      resolve(data)
    }).catch(err => {
      Vue.$loading.hide()

      Vue.$toast(err.message);
    })
  })

}
// 去登陆 phone(手机号) code（验证码）
const loginIn = (data = { phone: '', code: '' }) => {
  Vue.$loading.show()

  let codeData = {
    country_code: "86",
    "sys": "15",
    ...data
  }
  return new Promise((resolve, reject) => {
    loginMobile(codeData).then(data => {
      // 存储登陆信息
      mutations.getsyToken(data.token)
      mutations.getUid(data.uid)
      let userInfo = {
        login_token: data.token,
        login_uid: data.uid,
        login_phone: data.phone,
        login_insure_uid: data.insure_uid
      }
      CacheModule.set("userInfo", userInfo);
      Vue.$loading.hide()

      resolve(data)
    }).catch(err => {
      Vue.$loading.hide()
      Vue.$toast(err.message);
      reject(err)
    })
  })

}
export {
  geet,
  loginGetCode,
  loginIn
}